import React from 'react';
import { Route, IndexRoute, Redirect, IndexRedirect } from 'react-router';

import FootballHomePage from './containers/FootballHomePage';
import MoreNews from 'modules/News/containers/MoreNews';
import MostReadFootball from 'modules/Common/containers/MostReadFootball';

import FootballComponent from './components/Football';

import FootballLeagues from './containers/FootballLeagues';
import FootballLeaguesContainer from './containers/FootballLeaguesContainer';

import FootballLiveHome from './containers/FootballLiveHome';
import FootballLiveHomeHeader from './components/FootballLiveHomeHeader';
import FootballLiveHomeTabs from './containers/FootballLiveHomeTabs';
import FootballLiveHomeVidiprinterContainer from './containers/FootballLiveHomeVidiprinterContainer';

import FootballMatchCentreLayout from './containers/FootballMatchCentreLayout';
import FootballLiveMatchContainer from './containers/FootballLiveMatchContainer';
import FootballFixturesLayout from './containers/FootballFixturesLayout';
import FootballFixturesResults from './containers/FootballFixturesResults';
import FootballCompetitionFixturesResults from './containers/FootballCompetitionFixturesResults';
import FootballTeamFixturesResults from './containers/FootballTeamFixturesResults';
import FootballVidiprinterPageLayout from './containers/FootballVidiprinterPageLayout'
import FootballVidiprinterPageContainer from './containers/FootballVidiprinterPageContainer'

import FootballNav from './nav/FootballNav';
import FootballLiveCenterNav from './nav/FootballLiveCenterNav';

import FootballLiveMatchTeams from './containers/FootballLiveMatchTeams';
import FootballLiveMatchHomeTeam from './containers/FootballLiveMatchHomeTeam';
import FootballLiveMatchAwayTeam from './containers/FootballLiveMatchAwayTeam';

import FootballMatchArticle from './containers/FootballMatchArticle';
import FootballMatchStats from './components/FootballMatchStats';
import FootballMatchCommentary from './components/FootballMatchCommentary';
import FootballMatchTableContainer from './containers/FootballMatchTableContainer';
import FootballMatchHeadToHeadContainer from './containers/FootballMatchHeadToHeadContainer';
import FootballMatchFormContainer from './containers/FootballMatchFormContainer';
import FootballTipsCentre from './containers/FootballTipsCentre';
import FootballPaperTalk from './containers/FootballPaperTalk';

import ArticleContainer from 'modules/News/containers/ArticleContainer';
import Article from 'modules/News/components/Article';
import { newsArticleExpander } from 'modules/News/sitemap-helper.js';

import AdvertWrapper from 'modules/Common/components/AdvertWrapper';
import GooglePublisherTag from 'modules/Common/containers/GooglePublisherTag';
import FootballTips from 'modules/Common/containers/FootballTips';
import GptAdvert from 'modules/Common/components/GptAdvert';

import { fixturesResultsExpander, matchExpander, leagueExpander, competitionExpander, competitionMonthExpander } from './sitemap-helper.js';

const footballGpt = {
  GooglePublisherTag
};

const footBallHomeComponents = {
  MoreNews,
  AdvertWrapper,
  GptAdvert,
  MostReadFootball,
  FootballTips,
  ...footballGpt
};

const FootballLiveHomeComponents = {
  FootballLiveHomeHeader,
  FootballLiveHomeVidiprinterContainer,
  FootballLiveHomeTabs,
  AdvertWrapper,
  ...footballGpt
};

const FootballVidiprinterPageComponents = {
  FootballVidiprinterPageContainer,
  ...footballGpt
};

const FootballMatchCentreComponents = {
  FootballLiveMatchContainer,
  AdvertWrapper,
  ...footballGpt
};

const FootballFixturesComponents = {
  FootballFixturesResults,
  AdvertWrapper,
  ...footballGpt
};

const FootballLeaguesComponents = {
  FootballLeaguesContainer,
  AdvertWrapper,
  ...footballGpt
};

const FootballCompetitionFixturesComponents = {
  FootballCompetitionFixturesResults,
  AdvertWrapper,
  ...footballGpt
};

const FootballTeamFixturesComponents = {
  FootballTeamFixturesResults,
  AdvertWrapper,
  ...footballGpt
};

const TipsCentreComponents = {
  MoreNews,
  MostReadFootball,
  ...footballGpt
}

const PaperTalkComponents = {
  MoreNews,
  MostReadFootball,
  ...footballGpt
}

const footballRoutes = (
  <Route path="football" component={FootballComponent} subnav={FootballNav}>
    <Route component={FootballHomePage}> {/* layout manager*/}
      <IndexRoute sitemap={{}} components={footBallHomeComponents}/>
    </Route>
    <Route path="league-tables" component={FootballLeagues}>
      <IndexRoute components={FootballLeaguesComponents}/>
      <Route path=":name/:competition" sitemap={{expand: leagueExpander}} components={FootballLeaguesComponents}/>
    </Route>
    <Route path="live" subnav={FootballLiveCenterNav}>
      <Route component={FootballLiveHome}>
        <IndexRoute sitemap={{}} components={FootballLiveHomeComponents}/>
        <Route path="filter/ongoing" components={FootballLiveHomeComponents} filterBy="ongoing"/>
        <Route path="filter/up-next" components={FootballLiveHomeComponents} filterBy="upNext"/>
        <Route path="filter/finished" components={FootballLiveHomeComponents} filterBy="finished"/>
      </Route>
      <Route path="vidiprinter" component={FootballVidiprinterPageLayout}>
        <IndexRoute sitemap={{ changefreq: "always"}} components={FootballVidiprinterPageComponents}/>
      </Route>
      <Route path=":matchId" component={FootballMatchCentreLayout}>
        <Route components={FootballMatchCentreComponents}>
          <IndexRedirect to="commentary"/> {/* Safety net */}
          <Route path="commentary" sitemap={{expand: matchExpander}} component={FootballMatchCommentary}/>
          <Route path="preview" component={FootballMatchArticle} storyType="MATCH_PREVIEW"/>
          <Route path="stats" component={FootballMatchStats}/>
          <Route path="teams" component={FootballLiveMatchTeams}>
            <IndexRedirect to="/football/live/:matchId/teams/home"/> {/* Safety net */}
            <Route path="home" component={FootballLiveMatchHomeTeam}/>
            <Route path="away" component={FootballLiveMatchAwayTeam}/>
          </Route>
          <Route path="form" component={FootballMatchFormContainer}/>
          <Route path="head-to-head" component={FootballMatchHeadToHeadContainer}/>
          <Route path="table" component={FootballMatchTableContainer}/>
          <Route path="report" component={FootballMatchArticle} storyType="MATCH_REPORT"/>
          <Route path="reaction" component={FootballMatchArticle} storyType="MATCH_REACTION"/>
        </Route>
      </Route>
    </Route>
    <Route path="fixtures-results">
      <IndexRedirect to="/football/fixtures"/>
      <Redirect from=":date" to="/football/fixtures/:date"/>
    </Route>
    <Route path="fixtures" component={FootballFixturesLayout} fixturesResults="fixtures" >
      <IndexRoute components={FootballFixturesComponents}/>
      <Route path=":date" sitemap={{expand: fixturesResultsExpander}} components={FootballFixturesComponents}/>
      <Route path="competitions/:compName/:compId" components={FootballCompetitionFixturesComponents} >
        <IndexRoute sitemap={{expand: competitionExpander}} components={FootballCompetitionFixturesComponents} />
        <Route path=":month" sitemap={{expand: competitionMonthExpander, fixturesResults:"fixtures"}} components={FootballCompetitionFixturesComponents} />
      </Route>
      <Route path="teams/:teamName/:teamId/:compName/:compId" components={FootballTeamFixturesComponents} />
    </Route>
    <Route path="results" component={FootballFixturesLayout} fixturesResults="results" >
      <IndexRoute components={FootballFixturesComponents}/>
      <Route path=":date" sitemap={{expand: fixturesResultsExpander}} components={FootballFixturesComponents}/>
      <Route path="competitions/:compName/:compId" components={FootballCompetitionFixturesComponents} >
        <IndexRoute sitemap={{expand: competitionExpander}} components={FootballCompetitionFixturesComponents} />
        <Route path=":month" sitemap={{expand: competitionMonthExpander, fixturesResults:"results"}} components={FootballCompetitionFixturesComponents} />
      </Route>
      <Route path="teams/:teamName/:teamId/:compName/:compId" components={FootballTeamFixturesComponents} />
    </Route>
    <Route path="tips-centre" component={FootballTipsCentre}> {/* layout manager */}
      <IndexRoute components={TipsCentreComponents}/> {/* layout */}
    </Route>
    <Route path="paper-talk" component={FootballPaperTalk}> {/* layout manager */}
      <IndexRoute components={PaperTalkComponents}/> {/* layout */}
    </Route>
    <Route path="news/:title/:articleId"
           component={ArticleContainer}
           sport="football"
           rightHandContent={['mostReadFootball', 'topMpu', 'footballTips']}> {/* layout manager */}
      <IndexRoute sitemap={{expand: newsArticleExpander("football")}}
        components={{ Article, ...footBallHomeComponents }}/> {/* layout */}
    </Route>
  </Route>
)

export default footballRoutes



// WEBPACK FOOTER //
// ./modules/Football/routes.js